//import LocalStorage from 'localStorage'
import Hosts from '../../../Hosts';


const object_type = 'plano_accao'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`
//const api_list_route = `${Hosts.SIMCore_API}/cpf`
const api_list_route = companycode => `${Hosts.SIMCore_API}/${object_type}/${companycode}`


const base_endpoint = '/plano_accao'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    view: `${base_endpoint}_view`,
}

//console.log()
const data_interface = {
    id: '',
    info: {
        unique_code: '',
        companycode: '',
        name: '',
        tipo : '', 
        description: '', 
        cfp: [
            /*{
                id: '',
                nome: '',
                descricao: '',
                data_inicio: [
                    {
                        data: '',
                        estado: 'activo',
                    }
                ],
                data_submissao: [
                    {
                        data: '',
                        estado: 'activo',
                    }
                ],
                data_limite_fim: [
                    {
                        data: '',
                        estado: 'activo',
                    }
                ],
                data_marerial_suplementar: '',
                data_resposta_revisao: '',
                data_limite_edicao_artigo: '',
                data_decisao_final_revisor: '',
                data_final_processo: ''
            }*/
        ],
        topicos: [],
        convidados: [
            //{
            //    nome: '',
            //    area: '',
            //    instituicao: '',
            //    descricao: ''
            //}
        ],
        editores: [
            // {
            //     id: '',
            //     name: '',
            //     surname: ''
            // }
        ],
        reviewers: {
            max_articles: '',
            submit: 'Não',
            atribuition_type: 'Manual', // [manual, automatica]
            questions_visible_to_authors: 'false',
            questions: [],
            /*list: [
                // {
                //     id: '',
                //     name: '',
                //     surname: ''
                // }
            ],*/
        },
        authores: {
            max_articles: '1',
            /*list: [
                // {
                //     id: '',
                //     name: '',
                //     surname: ''
                // }
            ]*/
        },
        articles: {
            max_reviewers_article: '',
            review_type: 'Double-Blind', // [Duplamente Cega, Cega, Sem Restrições] 
            file_type: [ 
                'pdf', 
                'doc'
            ], 
            linguas: [],
            template: [],
            /*list: [
                // {
                //     id_article: '',
                //     title: ''
                // }
            ]*/
        },
       /*articles_reviewers : [
            // {
            //     id_article: '',
            //     id_reviewer: ''
            // },
        ],*/
        //aditiona_info: [],
        //ativo: true,
    },
    profile: { name: "Evento" }
}

export {
    object_type,
    endpoints,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route
}
